import React, { useCallback, useEffect, useState } from "react";
import { object } from "prop-types";

import { optionsType } from "../../prop-types";
import { Col, Row } from "reactstrap";
import "./buttonSelect.css";
import { NaturalPersonIcon } from "../../assets";
import {
  CLIENT_TYPE_LABELS,
  CLIENT_TYPE_VALUES,
} from "../../features/monitoring-queue-entry/constants/monitoringQueueEntryConstants";
import LegalEntityIcon from "../../assets/LegalEntityIcon";
import { Field } from "formik";
import SelectForClientType from "./SelectForClientType/SelectForClientType";

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
};

const FormikButtonSelect = ({ options, field, form: { setFieldValue } }) => {
  const [groupedOptions, setGroupedOptions] = useState({
    [CLIENT_TYPE_VALUES.COMPANY]: [],
    [CLIENT_TYPE_VALUES.PERSON]: [],
  });

  const value = getValue(options, field);

  useEffect(() => {
    if (options) {
      const tempGroup = {
        [CLIENT_TYPE_VALUES.COMPANY]: [],
        [CLIENT_TYPE_VALUES.PERSON]: [],
      };

      options.map((option) => {
        if (tempGroup[option.targetTypeCategory]) {
          tempGroup[option.targetTypeCategory].push(option);
        }

        return null;
      });

      setGroupedOptions(tempGroup);
    }
  }, [options]);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const getClassName = (option) => {
    const base =
      "d-flex justify-content-between selectable-button align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button";
    }
    return base;
  };

  const RenderIcon = useCallback(({ optionValue = "" }) => {
    if (optionValue === CLIENT_TYPE_VALUES.PERSON) {
      return <NaturalPersonIcon height={16} width={16} />;
    }

    if (optionValue === CLIENT_TYPE_VALUES.COMPANY) {
      return <LegalEntityIcon height={16} width={16} />;
    }

    return null;
  }, []);

  const RenderOption = ({ option, type }) => {
    if (option.length === 1) {
      const opt = option[0];
      return (
        <div
          className={getClassName(opt)}
          color="primary"
          outline
          onClick={() => handleChange(opt)}
        >
          <RenderIcon optionValue={opt.targetTypeCategory} />
          <span>{CLIENT_TYPE_LABELS[opt.label]}</span>
          <div />
        </div>
      );
    } else if (option.length) {
      return (
        <Field
          targetTypeCategory={option[0].targetTypeCategory}
          name={field.name}
          placeholder={CLIENT_TYPE_LABELS[option[0].targetTypeCategory]}
          options={option}
          component={SelectForClientType}
        />
      );
    } else {
      return (
        <div
          className="d-flex justify-content-between align-items-center no-option"
          color="primary"
          outline
          onClick={() => {}}
        >
          <RenderIcon optionValue={type} />
          <span>{type}</span>
          <div />
        </div>
      );
    }
  };

  return (
    <Row>
      <Col lg={6} className="pr-2 pl-0">
        <RenderOption
          option={groupedOptions[CLIENT_TYPE_VALUES.PERSON]}
          type={CLIENT_TYPE_VALUES.PERSON}
        />
      </Col>
      <Col lg={6} className="pl-2 pr-0">
        <RenderOption
          option={groupedOptions[CLIENT_TYPE_VALUES.COMPANY]}
          type={CLIENT_TYPE_VALUES.COMPANY}
        />
      </Col>
    </Row>
  );
};

FormikButtonSelect.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default FormikButtonSelect;



// WEBPACK FOOTER //
// ./src/components/formik/ButtonSelect.jsx